import React from 'react';
import { filterRowsByTeam } from './ocr/detectTeamRows';

const TEAM_LABELS = {
  blue: 'BLUE',
  red: 'RED',
  unknown: 'UNKNOWN',
};

const getSelectedWarning = (detection, selectedRows) => {
  if (detection.category === 'propDetails') return '';
  if (selectedRows.length === 5) return '';

  return `Expected approximately 5 ${detection.selectedTeamColor.toUpperCase()} player rows. Detected ${detection.summary.blue} Blue, ${detection.summary.red} Red, ${detection.summary.unknown} Unknown.`;
};

const RowDetectionDebug = ({ detections = [], selectedTeamColor = 'blue' }) => {
  if (!detections.length) return null;

  return (
    <div className="ocr-row-debug-panel">
      <div className="ocr-results-heading">
        <h4>Row Detection Debug</h4>
        <p>Temporary team-color boxes. Stat parsing is intentionally not active yet.</p>
      </div>

      {detections.map((detection, detectionIndex) => {
        const selectedRows = filterRowsByTeam(detection.rows, selectedTeamColor);
        const selectedWarning = getSelectedWarning(
          { ...detection, selectedTeamColor },
          selectedRows
        );

        return (
          <article className="ocr-row-debug-card" key={`${detection.category}-${detection.fileName}-${detectionIndex}`}>
            <header>
              <div>
                <strong>
                  {detection.label.toUpperCase()}
                  {detection.total > 1 ? ` #${detection.index + 1}` : ''}
                </strong>
                <span>{detection.fileName}</span>
              </div>
              <small>
                Candidates {detection.rows.length} / Blue {detection.summary.blue} / Red {detection.summary.red} / Unknown {detection.summary.unknown}
              </small>
            </header>

            {(detection.warning || selectedWarning) && (
              <p className="ocr-row-warning">{selectedWarning || detection.warning}</p>
            )}

            <div className="ocr-row-debug-image">
              {detection.previewUrl && <img src={detection.previewUrl} alt={`${detection.label} row boxes`} />}
              {detection.rows.map((row) => {
                const bounds = row.normalizedBounds;
                const isSelected = row.teamColor === selectedTeamColor;
                return (
                  <span
                    key={row.id}
                    className={`ocr-row-box ocr-row-box--${row.teamColor} ${isSelected ? 'is-selected' : ''}`}
                    style={{
                      left: `${bounds.x * 100}%`,
                      top: `${bounds.y * 100}%`,
                      width: `${bounds.width * 100}%`,
                      height: `${bounds.height * 100}%`,
                    }}
                  >
                    {isSelected ? 'SELECTED ' : ''}
                    {TEAM_LABELS[row.teamColor]} {Math.round(row.confidence * 100)}%
                  </span>
                );
              })}
            </div>

            <div className="ocr-row-debug-meta">
              <span>Candidates: {detection.rows.length}</span>
              <span>Blue: {detection.summary.blue}</span>
              <span>Red: {detection.summary.red}</span>
              <span>Unknown: {detection.summary.unknown}</span>
              <span>Selected Team: {selectedTeamColor.toUpperCase()}</span>
              <span>Selected Rows: {selectedRows.length}</span>
              <span>Detection Time: {detection.elapsedMs}ms</span>
            </div>

            <div className="ocr-row-table-wrap">
              <table className="ocr-row-table">
                <thead>
                  <tr>
                    <th>Row</th>
                    <th>Team</th>
                    <th>Confidence</th>
                    <th>X</th>
                    <th>Y</th>
                    <th>Width</th>
                    <th>Height</th>
                    <th>Votes</th>
                    <th>HSV</th>
                  </tr>
                </thead>
                <tbody>
                  {detection.rows.map((row) => (
                    <tr key={`${row.id}-table`} className={row.teamColor === selectedTeamColor ? 'is-selected' : ''}>
                      <td>{row.rowIndex + 1}</td>
                      <td>{TEAM_LABELS[row.teamColor]}</td>
                      <td>{row.confidence.toFixed(2)}</td>
                      <td>{row.normalizedBounds.x.toFixed(3)}</td>
                      <td>{row.normalizedBounds.y.toFixed(3)}</td>
                      <td>{row.normalizedBounds.width.toFixed(3)}</td>
                      <td>{row.normalizedBounds.height.toFixed(3)}</td>
                      <td>
                        B {row.votes.blue} / R {row.votes.red} / N {row.votes.unknown} / S {row.sampleCount}
                      </td>
                      <td>
                        H {row.averageHsv.h} / S {row.averageHsv.s} / V {row.averageHsv.v}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default RowDetectionDebug;
